module.exports = __webpack_public_path__ + "static/media/clock.86efb113.svg";